
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/targets/[encodedName]",
      function () {
        return require("private-next-pages/targets/[encodedName].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/targets/[encodedName]"])
      });
    }
  